module.exports = __webpack_public_path__ + "static/media/piano.e5fa3dae.jpg";